// extracted by mini-css-extract-plugin
module.exports = {"container":"DNxf-mVn","noVerticalSpace":"_3cegUb7g"};